import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {Unit} from '../../dashboard/monitoring/unit';
import {distinctUntilKeyChanged, filter, switchMap} from 'rxjs/operators';
import {UnitStatusModel} from '../../unit-status-manager/unit-status.model';
import {ModalWindowType} from '../../shared/modal-window/modal-window-type';
import {ModalWindowResponse} from '../../shared/modal-window/modal-window-response';
import {Observable, of} from 'rxjs';
import {UnitStatusManagerService} from '../../unit-status-manager/unit-status-manager.service';
import {ModalWindowService} from '../../shared/modal-window/modal-window.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {REST_BASE_URL} from '../../../lib/yii2-rest/rest.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-unit-command-list',
  templateUrl: './unit-command-list.component.html',
  styleUrls: ['./unit-command-list.component.scss']
})
export class UnitCommandListComponent implements OnInit {
  @Input() unit: Observable<Unit>;
  @Output() newUnitStatusId: EventEmitter<number> = new EventEmitter<number>();
  unitCommands: Observable<any>;

  constructor(
    protected unitStatusManager: UnitStatusManagerService,
    protected modalWindowService: ModalWindowService,
    protected translates: TranslateService,
    protected notif: NotificationsService,
    protected http: HttpClient,
    @Inject(REST_BASE_URL) protected restBaseUrl,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string,
  ) { }

  ngOnInit() {
    this.unitCommands = this.unit.pipe(
      filter(unit => !!unit),
      distinctUntilKeyChanged('id'),
      switchMap(
        (unit: Unit) => this.http.get(
          this.environmentApiBasepoint + 'unit/' + unit.id + '/command',
          {observe: 'body', params: (new HttpParams()).append('expand', 'commandName')}
        )
      )
    );
  }
  commandClick(unit: Unit, command: any) {
    const commandSubscription = this.unitStatusManager
      .needToChangeStatusWhenSendingCommand(unit.unitModel.unit_type_name, unit.unit_status_id, command.id)
      .pipe(
        switchMap(
          (result: Array<UnitStatusModel> | boolean) => {
            if (typeof result === 'boolean') {
              return this.modalWindowService.showWindow({
                modalWindowType: ModalWindowType.Confirmation,
                text: this.translates.instant('Do you wish to send command') + ' "' + command.command_name + '"?'
              });
            } else {
              return this.modalWindowService.showWindow({
                modalWindowType: ModalWindowType.Selection,
                text: this.translates.instant('Do you wish to change status and send command') + ' "' + command.command_name + '"?',
                selectParameters: {
                  items: result,
                  keyField: 'id',
                  displayedField: 'translatedDescription',
                }
              });
            }
          }
        ),
        switchMap(
          (result: ModalWindowResponse) => {
            if (result.confirmed && !result.selectionResult) {
              return this.http.patch(
                this.environmentApiBasepoint + 'unit/' + unit.id.toString() + '/command/' + command.id,
                {send: true},
                {observe: 'body'}
              );
            } else if (result.confirmed && result.selectionResult) {
              const requestBody = {
                unit_status_id: result.selectionResult
              };
              return this.http.patch(
                this.environmentApiBasepoint + 'unit/' + unit.id.toString(),
                requestBody
              );
            } else {
              return of(false);
            }
          }
        )
      ).subscribe(
        (result: any) => {
          if (result && result.unit_status_id) {
            this.newUnitStatusId.emit(result.unit_status_id);
          } else if (result) {
            this.notif.success(this.translates.instant('Command sent'));
          }
          commandSubscription.unsubscribe();
        }
      );
  }
}
